<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="body">
            <div class="center">
                <div class="c_left">
                    <div>题库管理</div>
                    <div>总数：{{ total }}</div>
                </div>
                <!-- , query: { item: encodeURIComponent(JSON.stringify(obj))} -->
                <div class="c_right" @click="btn_openAdd">添加题库</div>
            </div>
            <div class="bottom">
                <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="list" style="width: 100%;"
                    :height="'100%'">
                    <el-table-column prop="groupName" label="题库名称"></el-table-column>
                    <el-table-column prop="subjectName" label="学科"></el-table-column>
                    <!-- <el-table-column prop="optionContent" label="课堂"></el-table-column> -->
                    <el-table-column prop="questionCount" label="题目数量" width="150"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                    <el-table-column label="操作" width="220">
                        <template slot-scope="scope">
                            <!-- <el-button type="primary" size="small" plain>去传题</el-button> -->
                            <!-- list[scope.$index].id scope.row.id-->
                            <el-button type="primary" size="small" plain
                                @click="$router.push({ path: '/questionInfo', query: { id: scope.row.id } })">查看</el-button>
                            <el-button type="warning" size="small" plain @click="btn_edit(scope.$index)">修改</el-button>
                            <el-button type="danger" size="small" plain @click="btn_del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <el-dialog append-to-body title="添加题库" :visible.sync="dialogVisible" width="30%">
            <div class="pop">
                <div class="p_item">
                    <div class="pi_left">题库名称</div><el-input class="pi_right" v-model="questionBankName"
                        placeholder="请输入内容"></el-input>
                </div>
                <div class="p_item">
                    <div class="pi_left">学段</div>
                    <el-select class="pi_right" v-model="sectionId" placeholder="请选择" @change="sectionChange">
                        <el-option v-for="item in sectionArr" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="p_item">
                    <div class="pi_left">学科</div>
                    <el-select class="pi_right" v-model="subjectId" placeholder="请选择">
                        <el-option v-for="item in subjectArr" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    sectionSubject,
    userInfo,
    addQuestionGroup,
    questionGroupList,
    deleteQuestionGroup,
    editQuestionGroup
} from '@/apis/index'
export default {
    data() {
        return {
            dialogVisible: false,
            list: [],
            sectionArr: [],
            sectionId: '',
            subjectArr: [],
            subjectId: '',
            questionBankName: '',
            pageNum: 1,
            pageSize: 10,
            total: 0,
            editIndex: null,
            id: ''
        }
    },
    mounted() {
        this.getSectionSubject()
        this.getList()
    },
    methods: {
         // 学段变化事件
        sectionChange(e) {
            this.subjectId = ''
            this.subjectArr = []
            console.log(e, 'e', this.sectionArr.find(item => item.id == e));
            this.subjectArr = this.sectionArr.find(item => item.id == e).subjectList
        },
        btn_del(row) {
            this.$confirm('是否确定删除该题库？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteQuestionGroup(row.id).then(res => {
                    this.$message.success('删除成功')
                    this.pageNum = 1
                    this.getList()
                })
            })
        },
        btn_edit(index) {
            this.editIndex = index
            console.log(this.list[index], 'list');
            this.questionBankName = this.list[index].groupName
            this.sectionId = this.list[index].sectionId
            this.subjectId = this.list[index].subjectId
            this.id = this.list[index].id
            this.dialogVisible = true
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val
            this.getList()
        },

        getList() {
            questionGroupList(this.pageNum, this.pageSize).then(res => {
                console.log(res, 'questionGroupList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.total = res.data.total
                this.list = res.data.list
            })
        },
        submit() {
            if (this.id) {
                editQuestionGroup({
                    id: this.id,
                    groupName: this.questionBankName,
                    sectionId: this.sectionId,
                    subjectId: this.subjectId
                }).then(res => {
                    console.log(res, 'editQuestionGroup');
                    this.dialogVisible = false
                    this.$message.success('修改成功')
                    this.questionBankName = ''
                    this.pageNum = 1
                    this.getList()
                })
            } else {
                addQuestionGroup({
                    groupName: this.questionBankName,
                    sectionId: this.sectionId,
                    subjectId: this.subjectId
                }).then(res => {
                    console.log(res, 'addQuestionGroup');
                    this.dialogVisible = false
                    this.$message.success('添加成功')
                    this.questionBankName = ''
                    this.pageNum = 1
                    this.getList()
                })
            }

        },
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                userInfo().then(resA => {
                    console.log(resA, 'userInfo')
                    this.sectionArr = res.data
                    this.sectionId = resA.data.techSectionId
                    this.subjectId = ''
                    this.subjectArr = []
                    this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList
                })
            })
        },
        btn_openAdd() {
            this.dialogVisible = true
        },
        load() {
        }
    }
}
</script>

<style lang="scss" scoped>
.pop {
    width: 100%;

    .p_item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .pi_left {
            width: 60px;
        }

        .pi_right {
            flex: 1;
            margin-left: 20px;
        }
    }
}

.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.line2_ {
    word-break: break-all;
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.back {
    width: 1200px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    // margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
    box-sizing: border-box;

    img {
        width: 14px;
        height: 14px;

    }
}

.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-bottom: 20px;

    .center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 40px 0;

        .c_left {
            display: flex;
            align-items: center;

            div:nth-child(1) {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-right: 20px;
            }

            div:nth-child(2) {
                font-weight: 500;
                font-size: 14px;
                color: #999999;
            }
        }

        .c_right {
            width: 104px;
            height: 36px;
            background: #399AFF;
            border-radius: 8px 8px 8px 8px;
            font-weight: 800;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
        }
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
    }
}
</style>